/* eslint-disable no-unused-vars */
import { useState } from 'react';
import CoinMap from './Components/CoinMap';
import ARView from './Components/ARView';
import ARjs from './Components/ARjs';
// import InfoCard from './Components/InfoCard';
export default function App() {
  const [mode, setMode] = useState('map');
  const [selectedCoin, setSelectedCoin] = useState(null);

  return (
    <>
    {/* <ARjs/> */}
      {mode === 'map' ? (
        <CoinMap
          onEnterAR={(coin) => {
            setSelectedCoin(coin);
            setMode('ar');
          }}
        />
      ) : (
        <ARView
          coin={selectedCoin}
          onBack={() => {
            setSelectedCoin(null);
            setMode('map');
          }}
        />
      )}
    </>
  );
}



